import React from 'react';
import marked from 'marked';
import { Link } from '@reach/router';
import { CenteredContainer } from './../../Components/CenteredContainer';
import { LazyImage } from './../../Components/LazyImage';
import './Styles/Project.css';

export class Project extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      details: {}
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.projectStore
      .getProjectDetails(this.props.projectId)
      .then(response => {
        this.setMarkdown(response);
      })
      .catch(err => {
        // TODO redirect to 404 page
        this.setMarkdown({
          id: this.state.id,
          markdown: 'Unknown Project',
          coverImg: ''
        });
      });
  }

  render() {
    return (
      <CenteredContainer ratio="100%" maxWidth="50em">
        {!this.state.details.markdown ? (
          <div className="Spinner__Holder">
            <i className="fas fa-cog PlaySpinner__Icon" />
          </div>
        ) : (
          <React.Fragment>
            <LazyImage
              image={this.state.details.coverImg}
              size={{ width: 800, height: 250 }}
              alt="Project cover"
            />
            <Link to="/play">
              <i className="fas  fa-arrow-circle-left Project__Back" />
            </Link>
            <div
              className="Project__Content"
              dangerouslySetInnerHTML={this.rawMarkup()}
            />
          </React.Fragment>
        )}
      </CenteredContainer>
    );
  }

  setMarkdown = markdown => {
    this.setState({
      details: markdown
    });
  };

  rawMarkup = () => {
    let rawMarkup = marked(this.state.details.markdown);
    return { __html: rawMarkup };
  };
}
